import React from 'react'
import Pg1 from '../../../myapp/services/add-money/Pg/Pg1'

function PG1Page() {
  return (
    <Pg1/>
  )
}

export default PG1Page